const SupplyRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('./Dashboard.vue'),
    children: [
      {
        name: 'OrganizerDashboardShowPage',
        path: '/dashboard',
        component: () => import('./pages/Dashboard/OrganizerDashboardShowPage.vue')
      },
      {
        name: 'AudienceCreativeCreatePage',
        path: 'experiences/create',
        component: () => import('./pages/AudienceCreative/AudienceCreativeCreatePage.vue')
      },
      {
        name: 'VenueCreatePage',
        path: 'experiences/venues/create',
        component: () => import('./pages/Venue/VenueCreatePage.vue')
      },
      {
        name: 'SpaceCreatePage',
        path: 'experiences/inventory/create',
        component: () => import('./pages/Space/SpaceCreatePage.vue')
      },
      {
        name: 'ExperienceShowPage',
        path: 'experiences',
        component: () => import('./pages/Experience/ExperienceShowPage.vue'),
        children: [
          {
            name: 'VenueListPage',
            path: 'venues',
            component: () => import('./pages/Venue/VenueListPage.vue'),
            children: [
              {
                name: 'VenueBulkEditPage',
                path: 'edit',
                component: () => import('./pages/Venue/VenueBulkEditPage.vue')
              },
              {
                name: 'VenueShowPage',
                path: ':venueId',
                component: () => import('./pages/Venue/VenueShowPage.vue')
              },
            ]
          },
          {
            name: 'SpaceListPage',
            path: 'inventory',
            component: () => import('./pages/Space/SpaceListPage.vue'),
            children: [
              {
                name: 'SpaceBulkEditPage',
                path: 'edit',
                component: () => import('./pages/Space/SpaceBulkEditPage.vue')
              },
              {
                name: 'SpaceShowPage',
                path: ':spaceId',
                component: () => import('./pages/Space/SpaceShowPage.vue')
              },
            ]
          },
          {
            name: 'AudienceInsightsShowPage',
            path: 'audience-insights',
            component: () => import('./pages/AudienceInsights/AudienceInsightsShowPage.vue'),
          },
          {
            name: 'AudienceAvailabilityListPage',
            path: 'availabilities',
            component: () => import('./pages/AudienceAvailability/AudienceAvailabilityListPage.vue'),
            children: [
              {
                name: 'AudienceAvailabilityBulkEditPage',
                path: 'edit',
                component: () => import('./pages/AudienceAvailability/AudienceAvailabilityBulkEditPage.vue')
              },
              {
                name: 'AudienceAvailabilityShowPage',
                path: ':audienceAvailabilityId',
                component: () => import('./pages/AudienceAvailability/AudienceAvailabilityShowPage.vue')
              },
              {
                name: 'AudienceAvailabilityPreviewPage',
                path: ':audienceAvailabilityId/preview',
                component: () => import('./pages/AudienceAvailability/AudienceAvailabilityPreviewPage.vue')
              },
            ]
          },
          {
            name: 'AudienceCreativeListPage',
            path: '',
            component: () => import('./pages/AudienceCreative/AudienceCreativeListPage.vue'),
            children: [
              {
                name: 'AudienceCreativeBulkEditPage',
                path: 'edit',
                component: () => import('./pages/AudienceCreative/AudienceCreativeBulkEditPage.vue')
              },
              {
                name: 'AudienceCreativeShowPage',
                path: ':audienceCreativeId',
                component: () => import('./pages/AudienceCreative/AudienceCreativeShowPage.vue')
              },
              {
                name: 'AudienceCreativePreviewPage',
                path: ':audienceCreativeId/preview',
                component: () => import('./pages/AudienceCreative/AudienceCreativePreviewPage.vue')
              },
            ]
          },
        ]
      },
      {
        name: 'AudienceCreativeEditPage',
        path: 'experiences/:audienceCreativeId/edit',
        component: () => import('./pages/AudienceCreative/AudienceCreativeEditPage.vue')
      },
      {
        name: 'VenueEditPage',
        path: 'experiences/venues/:venueId/edit',
        component: () => import('./pages/Venue/VenueEditPage.vue')
      },
      {
        name: 'ShippingAreaCreatePage',
        path: 'shipping/create',
        component: () => import('./pages/ShippingArea/ShippingAreaCreatePage.vue')
      },
      {
        name: 'ShippingAreaEditPage',
        path: 'shipping/:shippingAreaId/edit',
        component: () => import('./pages/ShippingArea/ShippingAreaEditPage.vue')
      },
      {
        name: 'SamplingSpaceEditPage',
        path: 'experiences/inventory/sampling/:spaceId/edit',
        component: () => import('./pages/Space/SamplingSpaceEditPage.vue')
      },
      {
        name: 'OnsiteSpaceEditPage',
        path: 'experiences/inventory/onsite/:spaceId/edit',
        component: () => import('./pages/Space/OnsiteSpaceEditPage.vue')
      },
      {
        name: 'OmnichannelSpaceEditPage',
        path: 'experiences/inventory/omnichannel/:spaceId/edit',
        component: () => import('./pages/Space/OmnichannelSpaceEditPage.vue')
      },
      {
        name: 'AudienceSetCreatePage',
        path: '/audience-sets/create',
        component: () => import('./pages/AudienceSet/AudienceSetCreatePage.vue')
      },
      {
        name: 'AudienceSetEditPage',
        path: '/audience-sets/:formAudienceSetId/edit',
        component: () => import('./pages/AudienceSet/AudienceSetEditPage.vue')
      },
      {
        name: 'AudienceSetShowPage',
        path: '/audience-sets/:audienceSetId/preview',
        component: () => import('./pages/AudienceSet/AudienceSetShowPage.vue')
      },
      {
        name: 'AudienceSetListPage',
        path: '/listings',
        component: () => import('./pages/AudienceSet/AudienceSetListPage.vue')
      },
      {
        name: 'OfferListPage',
        path: '/offers',
        component: () => import('./pages/Offer/OfferListPage.vue')
      },
      {
        name: 'OfferShowPage',
        path: '/offers/:offerId',
        component: () => import('./pages/Offer/OfferShowPage.vue')
      },
      {
        name: 'ShippingAreaListPage',
        path: 'shipping',
        component: () => import('./pages/ShippingArea/ShippingAreaListPage.vue'),
        children: [
          {
            name: 'ShippingAreaShowPage',
            path: ':shippingAreaId',
            component: () => import('./pages/ShippingArea/ShippingAreaShowPage.vue')
          },
        ]
      },
      {
        name: 'RecapListPage',
        path: '/recaps',
        component: () => import('./pages/Recap/RecapListPage.vue')
      },
      {
        name: 'ProfileShowPage',
        path: '/profile',
        component: () => import('./pages/Profile/ProfileShowPage.vue'),
        children: [
          {
            name: 'MeShowPage',
            path: '/me',
            component: () => import('./pages/Profile/MeShowPage.vue')
          },
          {
            name: 'TeamShowPage',
            path: '/team',
            component: () => import('./pages/Profile/TeamShowPage.vue')
          },
          {
            name: 'PasswordEditPage',
            path: '/password',
            component: () => import('./pages/Profile/PasswordEditPage.vue')
          },
        ]
      },
      {
        name: 'OrganizerShowPage',
        path: '/team/organizers',
        component: () => import('./pages/Team/Organizer/OrganizerShowPage.vue')
      }
    ]
  },
  {
    path: '/welcome',
    name: 'OnboardOrganizer',
    component: () => import('@modules/host/pages/OnboardOrganizer.vue')
  },
  {
    path: '/wait-list',
    name: 'WaitListOrganizer',
    component: () => import('@modules/host/pages/WaitListOrganizer.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

export default SupplyRoutes